// AgeVerificationPinnedNotification.js
'use client';
import { connect } from 'react-redux';

import getOperationData from '../selector/getOperationData.js';
import addvalue from '../action/addvalue.js';
import AgeVerificationPinnedNotification from '../component/AgeVerificationPinnedNotification.jsx';
import openBindPhoneModal from '../action/openBindPhoneModal.js';

const mapStateToProps = state => {
  return {
    shouldShow: !!getOperationData(
      state,
      ['pinnedNotification'],
      'AgeVerificationPinnedNotification'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openPhoneBindingModal: () => dispatch(openBindPhoneModal()),
    openShopModal: () => dispatch(addvalue({ via: 'user-verification' })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgeVerificationPinnedNotification);
